<template>
  <div class="home">
      <div class="header">
          <headerShow @changeLanguage="changeLanguageFN"></headerShow>
      </div>
      <div class="homeBody reportCards">
          <div class="reportAllClass imgClass">
              <!-- <div>{{this.title}}</div> -->
              <div class="forTopHeight" style="width:100%"></div>
              <div class="htmlBoldTitle" style="width:100%">{{this.title}}<div class="htmlcommenTime">{{reporterVal}}</div></div>
              <div class="forLine" style="width:100%"></div>
              <div v-if="video" class="videoUse">
                  <div class="bg">
                    
                      <div style="color: Black">
                          <div class="innercolor">iformats</div>
                        <!-- <div class="innercolor">iformats</div>
                        <div class="innercolor">iformats</div>
                        <div class="innercolor">iformats</div>
                        <div class="innercolor">iformats</div>
                        <div class="innercolor">iformats</div>
                        <div class="innercolor">iformats</div>
                        <div class="innercolor">iformats</div>
                        <div class="innercolor">iformats</div>
                        <div class="innercolor">iformats</div>
                        <div class="innercolor">iformats</div> -->
                    </div>

                  </div>
                  <div v-html="videoHtml" class="foheightVideo"></div>
                  
                    <!-- preload="auto" -->
                  <!-- <video  class="videoClass" style="width:100%" controls="controls" autoplay="autoplay" controlsList="nodownload" >
                        <source :src="''+$staticUrl+'/admin/smg/file/getVideo?name='+video" type="video/mp4" />
                  </video> -->
              </div>
                <div class="markdown-body ql-editor" style="width:100%" v-html="content"></div>
          </div>
      </div>

      <footerView></footerView>
  </div>
</template>

<script>
import headerShow from '@/components/headerShow.vue'
import footerView from '@/components/footer.vue'
import { perListDetailRequest } from '../request/request'
export default {
  name: 'costum',
  components: {
    headerShow, footerView
  },
  data () {
    return {
      videoHtml:'',
      reporterVal: '',
      mailModel: '',
      peoModel: '',
      companyModel: '',
      postModel: '',
      confirmModal: false,
      languageVal: 'ch',
      id: '',
      title: '',
      content: '',
      video: '',
      myVideo:null
    }
  },
  computed: {
  },
  mounted () {
    this.languageVal = localStorage.getItem('language') === 'en' ? 'en' : 'ch'
  },
  destroyed () {
    this.myVideo.dispose()
  },
  created () {
    this.$nextTick(() => {
      this.initFN()
      document.scrollingElement.scrollTop = 0
      // this.myVideo = videojs('myVideo', {
      //       bigPlayButton: true,
      //       textTrackDisplay: false,
      //       posterImage: false,
      //       errorDisplay: false,
      //   })
        // this.myVideo.play()
    })
  },
  destroyed () {
    this.myVideo.dispose()
    },
  watch: {
    // '$route' (to, from) {
    //   this.initFN()
    // }
  },
  methods: {
    async perListDetailRequestFN (e) {

      var that=this
        var changeVideo = function (vdoSrc) {
          if(that.myVideo){}else{
                that.myVideo = videojs('myVideoo', {
                    bigPlayButton: true,
                    textTrackDisplay: false,
                    posterImage: false,
                    errorDisplay: false,
                })
            }
            if (/\.m3u8$/.test(vdoSrc)) { //判断视频源是否是m3u8的格式
                that.myVideo.src({
                    src: vdoSrc,
                    type: 'application/x-mpegURL' //在重新添加视频源的时候需要给新的type的值
                })
            } else {
                that.myVideo.src(vdoSrc)
            }
            that.myVideo.load();
            // let mark=localStorage.markLoad
            // if(mark!='1'){
            //   localStorage.markLoad='1'
            //   location.reload()
            // }else{
            //   localStorage.markLoad='0'
            // }
            // that.myVideo.play();
        }


      var res = await perListDetailRequest(e)
      if (res.data.code === 0) {
        debugger
        this.title = res.data.data.title
        this.video = res.data.data.newVideo//video

        this.videoHtml=`<video id="myVideoo" class="video-js vjs-default-skin vjs-big-play-centered" controls preload="auto" data-setup='{}' style='width: 100%;height: auto'>

                        <source id="sourcee" src="${this.video}" type="application/x-mpegURL"></source>
                    </video>`

        // changeVideo(this.video);
        

        this.content = res.data.data.content
        var time = res.data.data.updateTime ? res.data.data.updateTime.substring(0, 10) : ''
        var name = res.data.data.announcer ? res.data.data.announcer : ''
        // this.reporterVal = name + ' ' + time
        this.$nextTick(() => {
          this.myVideo = videojs('myVideoo', {
                bigPlayButton: true,
                textTrackDisplay: false,
                posterImage: false,
                errorDisplay: false,
            })
          var a = document.querySelector('.markdown-body').querySelectorAll('img')
          var b
          for (var i = 0; i < a.length; i++) {
            b = a[i]
            b.parentNode.style.textAlign = 'center'
          }
        })
      }
    },
    changeLanguageFN (e) {
      this.languageVal = e === 'en' ? 'en' : 'ch'
      localStorage.language = this.languageVal
      this.initFN()
    },
    initFN () {
      this.id = this.$route.query.id
      this.perListDetailRequestFN({ id: this.id, lang: this.languageVal })
    }
  }
}
</script>

<style>
  .foheightVideo .myVideo-dimensions{
    /* height: 800px !important; */
  }
  .foheightVideo>div{
    /* height: 800px !important; */
  }
</style>
<style lang="scss">
.patternleftBg .myVideo-dimensions{

}
.foheightVideo .myVideo-dimensions{
  height: 800px !important;
}
.imgClass img{
    max-width: 100%;
}
.cardContent{
    width: 100%;
    height: 20vh;
    @include centerLine
}
.cardImg{
    @include containbackground;
    width: 30%;
    height:100%;
    // background-position-y: 0;
    background-image:  url('../assets/3.png');
}
.cardTxt{
    width: 60%;
    height:100%
}
.cardTitle{
    color:#40A0F0
}
.reportAllClass{
    padding-top: 20px;
    // width: 80%;
    margin: 0 auto;
    background: transparent;
    min-height: 75vh;
    padding: 1vw 5vw;
}
.reportBtn{
    background:linear-gradient(90deg,rgba(64,160,240,1) 0%,rgba(122,189,245,1) 100%);
    color:white
}
</style>
